import { Typography } from "@mui/material";

export default function Type({ data }) {
  return (
    <Typography color="text.main" variant="h6">
      {data?.type}
    </Typography>
  );
}
